module.exports = __webpack_public_path__ + "static/media/icons-mail.3b41e1b3.svg";